module.exports = __webpack_public_path__ + "img/Bingo Journey.071fe50b.png";